import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import HomebuyingSupport from "@/pages/HomebuyingSupport";

export const Route = createFileRoute("/homebuying-support")({
  head: () => seoHead("/homebuying-support"),
  component: HomebuyingSupport,
});
